import { render, staticRenderFns } from "./InstantLoginView.vue?vue&type=template&id=5e12225b&scoped=true"
import script from "./InstantLoginView.vue?vue&type=script&lang=ts"
export * from "./InstantLoginView.vue?vue&type=script&lang=ts"
import style0 from "./InstantLoginView.vue?vue&type=style&index=0&id=5e12225b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e12225b",
  null
  
)

export default component.exports